import { Button, } from "@bracket/ui";
import { useWallet, } from "@store";
import styled from "styled-components";
import { Div, } from "@bracket/ui/nodes";



export declare type WalletStoreConnectorProps = {
	width?: string;
	onSuccess?: () => void;
	connectLabel?: string;
	disconnectLabel?: string;
	scale?: string;
	justify?: "flex-start" | "center" | "flex-end";
};



export const WalletStoreConnector = ({
	width,
	onSuccess = () => {},
	connectLabel = "Connect Wallet",
	disconnectLabel = "Disconnect",
	scale,
	justify,
}: WalletStoreConnectorProps) => {

	const { ready, anonymous, connect, disconnect, } = useWallet();
	const props = Object.assign({}, width ? { width } : {});

	if(!ready) {
		return <Brace $justify={justify} />;
	}

	if(anonymous) {
		return (
			<Brace $justify={justify}>
				<Button label={connectLabel} onClick={_ => { connect(); hideAnonConnector(); onSuccess(); }} {...props} style={{ scale, }} />
			</Brace>
		);
	}

	return (
		<Brace $justify={justify}>
			<Button label={disconnectLabel} onClick={_ => { disconnect(); hideAnonConnector(); onSuccess(); }} {...props} />
		</Brace>
	);
}
;

let hideAnonConnectorTimeout: NodeJS.Timeout | null = null;

const hideAnonConnector = ( attempt = 0 ) => {

	if(hideAnonConnectorTimeout) {
		clearTimeout(hideAnonConnectorTimeout);
	}

	hideAnonConnectorTimeout = setTimeout(() => {
		try {

			globalThis.document.querySelector("w3m-modal").shadowRoot
				.querySelector('wui-flex > wui-card > w3m-router').shadowRoot
				.querySelector("w3m-router-container > w3m-connect-view").shadowRoot
				.querySelector("wui-flex > wui-flex > w3m-wallet-login-list").shadowRoot
				.querySelector("wui-flex > w3m-connector-list").shadowRoot
				.querySelector("wui-flex > w3m-connect-external-widget")
				.setAttribute('style', 'display:none');
		}
		catch(_e) {
			if(attempt < 3) {
				hideAnonConnector(attempt + 1);
				return;
			}
			// console.error("anonymous connector could not found", _e);
		}
		hideAnonConnectorTimeout = null;
	}, 50);

}

const Brace = styled(Div)<{ $justify?: "flex-start" | "center" | "flex-end"; }>`
	display: flex;
	justify-content: ${props => props.$justify || "center"};
	justify-content: flex-end;
	align-items: center;
	flex: ${props => props.$justify ? "1" : "0"};
`;
